import React, { useEffect, useState } from "react";
import styled from "styled-components";
import lodash from 'lodash';

import FetchModule from "../../../Model/Share/Network/FetchModule";
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import NotRegistrationCardModal from '../../../Model/Share/Normal/NotRegistrationCardModal';
import useTossCardRegister from '../../../Model/Share/Normal/useTossCardRegister';
import SendCompleteModal from "../Model/SendCompleteModal";
import SendMemberSelectModal from "../Model/SendMemberSelectModal";
import AutoMessageEditModal from "../Model/AutoMessageEditModal";

import SendMessageBox from "../Model/SendMessageBox";
import AutoMessageSettingBox from "../Model/AutoMessageSettingBox";
import MessageHistoryBox from "../Model/MessageHistoryBox";
import AutoNotificationBox from "../Model/AutoNotificationBox";
import PhoneNumberManagementBox from "../Model/PhoneNumberManagementBox";
import { UNSUBSCRIBE_TEXT } from "../Model/ContentInput";

const VALID_MESSAGE_TABS = ['SendMessage', 'SettingAutoMessage', 'AutoNotification', 'MessageHistory', 'PhoneNumberManagement'];

export default function MessageSendPage() {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const registerCard = useTossCardRegister();

  const [isSending, setIsSending] = useState(false);
  const [storeName, setStoreName] = useState('');
  const [content, setContent] = useState('');
  const [pricing, setPricing] = useState({ sms: 30, lms: 60, alimtalk: 10 });

  const [isRegistrationCard, setIsRegistrationCard] = useState(false);

  const [totalMembers, setTotalMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);

  const [isProgress, setIsProcess] = useState(false);
  const [isClickedTotalSetting, setIsClickedTotalSetting] = useState(false);

  const [isViewRegistrationCard, setIsViewRegistrationCard] = useState(false);
  const [isViewCompleteSend, setIsViewCompleteSend] = useState(false);

  const [isViewMessageEditModal, setIsViewMessageEditModal] = useState(false);
  const [isClickedSelectedMember, setIsClickedSelectedMember] = useState(false);

  const [selectedData, setSelectedData] = useState(undefined);
  const [isEditPush, setIsEditPush] = useState(false);
  
  const [messageHistory, setMessageHistory] = useState([]);
  const [viewMessageHistory, setViewMessageHistory] = useState([]);
  const [nowPage, setNowPage] = useState(0);
  const [totalPage, setTotalPage] = useState(1);

  const [clickDivision, setClickDivision] = useState(() => {
    const stored = window.sessionStorage.getItem('messageSendTab');
    return VALID_MESSAGE_TABS.includes(stored) ? stored : 'SendMessage';
  });
  const [rendering, setRendering] = useState(false);

  const [registration, setRegistration] = useState({
    newRegistration: {
      id: 0,
      storeId: 0,
      division: 'NewRegistration',
      isUseSetting: false,
      title: t('messageSend.editModal.descNewRegistration'),
      text: '안녕하세요. {store_name} 신규회원으로 등록하신 것을 환영합니다. 즐거운 운동시간 되세요. 감사합니다.'
    },
    reRegistration: {
      id: 0,
      storeId: 0,
      division: 'ReRegistration',
      isClicked: false,
      title: t('messageSend.editModal.descReRegistration'),
      text: '안녕하세요. {store_name}에 재등록해주신 것을 감사드립니다. 계속해서 만족을 드릴 수 있는 {store_name}이 되겠습니다. 감사합니다.'
    }
  })

  const [attendanceClass, setAttendanceClass] = useState({
    attendance: {
      id: 0,
      storeId: 0,
      division: 'Attendance',
      isUseSetting: false,
      title: t('messageSend.editModal.descAttendance'),
      text: '안녕하세요. {store_name}입니다. {user_name}님이 출석하셨습니다. 감사합니다.'
    },
    lastAttendance: {
      id: 0,
      storeId: 0,
      division: 'LastAttendance',
      isUseSetting: false,
      title: t('messageSend.editModal.descLastAttendance', { day: 0, time: 0 }),
      text: '안녕하세요. {store_name}입니다. {user_name}님, 마지막으로 방문해 운동하신지 7일이 지났습니다. 오랜만에 운동하러 나오시는 건 어떨까요? 감사합니다.',
      applyDay: 0,
      applyTime: 0,
      applyMinute: 0
    },
    onReserve: {
      id: 0,
      storeId: 0,
      division: 'OnReserve',
      isUseSetting: false,
      title: t('messageSend.editModal.descOnReserve'),
      text: '안녕하세요. {store_name}입니다. 수업 예약이 완료되었습니다. 수업명: {class_name} 예약 시간: {reserve_time} 강사명: {coach_name} 수업 시간에 늦지 않게 참석해 주세요. 감사합니다.'
    },
    cancelReserve: {
      id: 0,
      storeId: 0,
      division: 'CancelReserve',
      isUseSetting: false,
      title: t('messageSend.editModal.descCancelReserve'),
      text: '안녕하세요. {store_name}입니다. 고객님의 예약이 취소되었습니다. 감사합니다.'
    },
    beforeReserve: {
      id: 0,
      storeId: 0,
      division: 'BeforeReserve',
      isUseSetting: false,
      title: t('messageSend.editModal.descBeforeReserve', { time: 0 }),
      text: '안녕하세요. {store_name}입니다. 예약한 수업 1시간 전입니다. 수업명: {class_name} 예약 시간: {reserve_time} 강사명: {coach_name} 수업 시간에 늦지 않게 참석해 주세요. 감사합니다.',
      applyTime: 0
    },
    absence: {
      id: 0,
      storeId: 0,
      division: 'Absence',
      isUseSetting: false,
      title: t('messageSend.editModal.descAbsence'),
      text: '안녕하세요. {store_name}입니다. 예약한 수업에 결석하셨습니다. 수업명: {class_name} 예약 시간: {reserve_time} 강사명: {coach_name} 감사합니다.'
    }
  })

  const [expired, setExpired] = useState({
    beExpiredMembership: [
      {
        id: 0,
        storeId: 0,
        division: 'BeExpiredMembership',
        isUseSetting: false,
        title: t('messageSend.editModal.descBeExpiredMembership', { day: 0, time: 0 }),
        text: '안녕하세요. {store_name}입니다. {membership_name}의 잔여일이 1일 남았습니다. 재등록 문의는 언제든지 연락 주세요. 감사합니다.',
        applyDay: 0,
        applyTime: 0
      }
    ],
    beExpiredLocker: [
      {
        id: 0,
        storeId: 0,
        division: 'BeExpiredLocker',
        isUseSetting: false,
        title: t('messageSend.editModal.descBeExpiredLocker', { day: 0, time: 0 }),
        text: '안녕하세요. {store_name}입니다. 사용중이신 락커의 잔여일이 1일 남았습니다. 만료일 전 락커를 비워주세요. 감사합니다.',
        applyDay: 0,
        applyTime: 0
      }
    ],
    expiredMembership: {
      id: 0,
      storeId: 0,
      division: 'ExpiredMembership',
      isUseSetting: false,
      title: t('messageSend.editModal.descExpiredMembership', { time: 0 }),
      text: '안녕하세요. {store_name}입니다. {membership_name}의 잔여 횟수가 1회 남았습니다. 재등록 문의는 언제든지 연락 주세요. 감사합니다.',
      applyTime: 0
    },
    hadBeenExpiredMembership: [
      {
        id: 0,
        storeId: 0,
        division: 'HadBeenExpiredMembership',
        isUseSetting: false,
        title: t('messageSend.editModal.descHadBeenExpiredMembership', { day: 0, time: 0 }),
        text: '안녕하세요. {store_name}입니다. {membership_name}이 만료되었습니다. 재등록 문의는 언제든지 연락 주세요. 감사합니다.',
        applyDay: 0,
        applyTime: 0
      }
    ],
    hadBeenExpiredLocker: [
      {
        id: 0,
        storeId: 0,
        division: 'HadBeenExpiredLocker',
        isUseSetting: false,
        title: t('messageSend.editModal.descHadBeenExpiredLocker', { day: 0, time: 0 }),
        text: '안녕하세요. {store_name}입니다. 락커의 사용기한 만료일이 1일이 지났습니다. 방문해 락커를 비워주세요. 감사합니다.',
        applyDay: 0,
        applyTime: 0
      }
    ],
    applyMembershipHolding: {
      id: 0,
      storeId: 0,
      division: 'ApplyMembershipHolding',
      isUseSetting: false,
      title: t('messageSend.editModal.descApplyMembershipHolding'),
      text: '안녕하세요. {store_name}입니다. 고객님의 홀딩신청이 정상적으로 완료되었습니다. 홀딩시작일: {holding_start_date} 홀딩종료일: {holding_end_date} 홀딩기간 중 취소를 원하시는 경우 편하게 연락 주세요. 감사합니다.',
    },
    startMembershipHolding: {
      id: 0,
      storeId: 0,
      division: 'StartMembershipHolding',
      isUseSetting: false,
      title: t('messageSend.editModal.descStartMembershipHolding', { day: 0, time: 0 }),
      text: '안녕하세요. {store_name}입니다. 홀딩중인 {membership_name}의 활성화 1일 전입니다. 홀딩시작일: {holding_start_date} 홀딩종료일: {holding_end_date} 날짜 변경을 원하시는 경우 편하게 연락 주세요. 감사합니다.',
      applyDay: 0,
      applyTime: 0
    }
  })

  const [pushExpired, setPushExpired] = useState(() => lodash.cloneDeep(expired));
  const [pushRendering, setPushRendering] = useState(false);
  const [duplicateLimit, setDuplicateLimit] = useState({
    isDuplicateSmsLimited: false,
    isDuplicatePushLimited: false,
    isDuplicateKakaoLimited: false
  });

  // 카드 등록 여부 조회 API //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('message/status', 'GET');

        if (responseData.status === 200) {
          setStoreName(responseData.data.storeName);
          setIsRegistrationCard(responseData.data.isRegistrationCard);
        }
      }
    )();
  }, [])

  // 메세지 단가 조회 API //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('message/pricing', 'GET');

        if (responseData.status === 200) {
          let newPricing = { sms: 30, lms: 60, alimtalk: 10 };

          responseData.data.forEach((item) => {
            if (item.messageType === 'SMS') newPricing.sms = item.unitPrice;
            else if (item.messageType === 'LMS') newPricing.lms = item.unitPrice;
            else if (item.messageType === 'ALIMTALK') newPricing.alimtalk = item.unitPrice;
          });

          setPricing(newPricing);
        }
      }
    )();
  }, [])

  // 전체 회원 목록 조회 API //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/status_all', 'GET');

        if (responseData.status === 200) {
          let newMembers = responseData.data.slice();

          newMembers.map((data) => data.isClicked = false);

          setTotalMembers(newMembers);
        }
        else setTotalMembers([]);
      }
    )();
  }, [])

  // 중복 알림 제한 설정 조회 API //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('system/settings', 'GET');

        if (responseData.status === 200) {
          const notification = responseData.data.notification ?? {};

          setDuplicateLimit({
            isDuplicateSmsLimited: notification.isDuplicateSmsLimited ?? false,
            isDuplicatePushLimited: notification.isDuplicatePushLimited ?? false,
            isDuplicateKakaoLimited: notification.isDuplicateKakaoLimited ?? false
          });
        }
      }
    )();
  }, [])

  // 자동 메시지 설정 조회 API //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('message_setting/', 'GET');

        if (responseData.status === 200) {
          let list = responseData.data.messageSettings.slice();
          let newRegistration = lodash.cloneDeep(registration);
          let newAttendanceClass = lodash.cloneDeep(attendanceClass);
          let newExpired = lodash.cloneDeep(expired);

          list.map((data, index) => {
            if (data.division === 'NewRegistration') {
              newRegistration.newRegistration.id = data.id;
              newRegistration.newRegistration.storeId = data.storeId;
              newRegistration.newRegistration.division = 'NewRegistration';
              newRegistration.newRegistration.isUseSetting = data.isUseSetting;
              newRegistration.newRegistration.text = data.text;
              newRegistration.newRegistration.title = data.title;
            }
            else if (data.division === 'ReRegistration') {
              newRegistration.reRegistration.id = data.id;
              newRegistration.reRegistration.storeId = data.storeId;
              newRegistration.reRegistration.division = 'ReRegistration';
              newRegistration.reRegistration.isUseSetting = data.isUseSetting;
              newRegistration.reRegistration.text = data.text;
              newRegistration.reRegistration.title = data.title;
            }
            else if (data.division === 'Attendance') {
              newAttendanceClass.attendance.id = data.id;
              newAttendanceClass.attendance.storeId = data.storeId;
              newAttendanceClass.attendance.division = 'Attendance';
              newAttendanceClass.attendance.isUseSetting = data.isUseSetting;
              newAttendanceClass.attendance.text = data.text;
              newAttendanceClass.attendance.title = data.title;
            }
            else if (data.division === 'LastAttendance') {
              newAttendanceClass.lastAttendance.id = data.id;
              newAttendanceClass.lastAttendance.storeId = data.storeId;
              newAttendanceClass.lastAttendance.division = 'LastAttendance';
              newAttendanceClass.lastAttendance.isUseSetting = data.isUseSetting;
              newAttendanceClass.lastAttendance.text = data.text;
              newAttendanceClass.lastAttendance.title = data.title;
              newAttendanceClass.lastAttendance.applyDay = data.applyDay;
              // 마지막 출석 발송시각 정수(시/분) → "HH:MM" 문자열 정규화 //
              newAttendanceClass.lastAttendance.applyTime = `${String(data.applyTime ?? 0).padStart(2, '0')}:${String(data.applyMinute ?? 0).padStart(2, '0')}`;
            }
            else if (data.division === 'OnReserve') {
              newAttendanceClass.onReserve.id = data.id;
              newAttendanceClass.onReserve.storeId = data.storeId;
              newAttendanceClass.onReserve.division = 'OnReserve';
              newAttendanceClass.onReserve.isUseSetting = data.isUseSetting;
              newAttendanceClass.onReserve.text = data.text;
              newAttendanceClass.onReserve.title = data.title;
            }
            else if (data.division === 'CancelReserve') {
              newAttendanceClass.cancelReserve.id = data.id;
              newAttendanceClass.cancelReserve.storeId = data.storeId;
              newAttendanceClass.cancelReserve.division = 'CancelReserve';
              newAttendanceClass.cancelReserve.isUseSetting = data.isUseSetting;
              newAttendanceClass.cancelReserve.text = data.text;
              newAttendanceClass.cancelReserve.title = data.title;
            }
            else if (data.division === 'BeforeReserve') {
              newAttendanceClass.beforeReserve.id = data.id;
              newAttendanceClass.beforeReserve.storeId = data.storeId;
              newAttendanceClass.beforeReserve.division = 'BeforeReserve';
              newAttendanceClass.beforeReserve.isUseSetting = data.isUseSetting;
              newAttendanceClass.beforeReserve.text = data.text;
              newAttendanceClass.beforeReserve.title = data.title;
              newAttendanceClass.beforeReserve.applyTime = data.applyTime;
            }
            else if (data.division === 'Absence') {
              newAttendanceClass.absence.id = data.id;
              newAttendanceClass.absence.storeId = data.storeId;
              newAttendanceClass.absence.division = 'Absence';
              newAttendanceClass.absence.isUseSetting = data.isUseSetting;
              newAttendanceClass.absence.text = data.text;
              newAttendanceClass.absence.title = data.title;
            }
            // 만료/홀딩 division은 공용 헬퍼로 반영 (applyTime/applyMinute 정수 → "HH:MM" 정규화 포함) //
            else {
              applyExpiredSetting(newExpired, data);
            }
          });

          setIsClickedTotalSetting(responseData.data.isUseAutoMessageSetting);
          setRegistration(newRegistration);
          setAttendanceClass(newAttendanceClass);
          setExpired(newExpired);
        }
      }
    )();
  }, [rendering])

  // 자동 푸시 설정 조회 API //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('push_setting/', 'GET');

        if (responseData.status === 200) {
          let newPushExpired = lodash.cloneDeep(pushExpired);

          responseData.data.pushSettings.map((data) => applyExpiredSetting(newPushExpired, data));

          setPushExpired(newPushExpired);
        }
      }
    )();
  }, [pushRendering])


  // 메시지 발송 내역 조회 API //
  useEffect(() => {
    if (clickDivision === 'MessageHistory') {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.getDataVersion2('message_setting/history', 'GET');

          if (responseData.status === 200) {
            setMessageHistory(responseData.data);
            setTotalPage(Math.ceil(responseData.data.length/10));
            setNowPage(0);
          }
          else {
            setMessageHistory([]);
            setTotalPage(1);
            setNowPage(0);
          }
        }
      )();
    }
  }, [clickDivision])

  useEffect(() => {
    setViewMessageHistory(messageHistory.slice((nowPage * 10), (nowPage * 10) + 10));
  }, [messageHistory, nowPage])

  function onClickTab(tab) {
    setClickDivision(tab);
    window.sessionStorage.setItem('messageSendTab', tab);
  }

  // 중복 알림 제한 토글 변경 API //
  function onClickDuplicateLimit(key) {
    let newDuplicateLimit = { ...duplicateLimit, [key]: !duplicateLimit[key] };

    setDuplicateLimit(newDuplicateLimit);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('system/duplicate', 'POST', newDuplicateLimit);

        if (responseData.status !== 200) {
          setDuplicateLimit(duplicateLimit);
          alert(t('messageSend.autoMessage.duplicateLimitServerError'));
        }
      }
    )();
  }

  // 만료/홀딩 설정 단건 필드 반영 (applyTime/applyMinute 정수 → "HH:MM" 문자열) //
  function assignExpiredSetting(target, data) {
    let hour = String(data.applyTime ?? 0).padStart(2, '0');
    let minute = String(data.applyMinute ?? 0).padStart(2, '0');

    target.id = data.id;
    target.storeId = data.storeId;
    target.division = data.division;
    target.isUseSetting = data.isUseSetting;
    target.text = data.text;
    target.title = data.title;
    target.applyDay = data.applyDay;
    target.applyTime = `${hour}:${minute}`;
  }

  // 만료/홀딩 리스트(복수 건) 반영 //
  function upsertExpiredSettingList(list, data) {
    if (list[0].id === 0 || list[0].id === data.id) {
      assignExpiredSetting(list[0], data);
      return;
    }

    for (let i = 0; i < list.length; i++) {
      if (list[i].id === data.id) {
        assignExpiredSetting(list[i], data);
        return;
      }
    }

    let newItem = {};

    assignExpiredSetting(newItem, data);
    list.push(newItem);
  }

  // 만료/홀딩 설정 1건을 expired 구조에 반영 (자동메시지·자동알림 공용) //
  function applyExpiredSetting(target, data) {
    if (data.division === 'BeExpiredMembership') upsertExpiredSettingList(target.beExpiredMembership, data);
    else if (data.division === 'BeExpiredLocker') upsertExpiredSettingList(target.beExpiredLocker, data);
    else if (data.division === 'ExpiredMembership') assignExpiredSetting(target.expiredMembership, data);
    else if (data.division === 'HadBeenExpiredMembership') upsertExpiredSettingList(target.hadBeenExpiredMembership, data);
    else if (data.division === 'HadBeenExpiredLocker') upsertExpiredSettingList(target.hadBeenExpiredLocker, data);
    else if (data.division === 'ApplyMembershipHolding') assignExpiredSetting(target.applyMembershipHolding, data);
    else if (data.division === 'StartMembershipHolding') assignExpiredSetting(target.startMembershipHolding, data);
  }

  // UTF-8 바이트 계산 //
  function checkValueByte(str) {
    let byteLength = 0;

    for (let i = 0, strLength = str.length; i < strLength; i++) {
      let code = str.charCodeAt(i);

      if (code < 0x0080) byteLength += 1;
      else if (code < 0x0800) byteLength += 2;
      else if (code < 0xD800) byteLength += 3;
      else if (code < 0xDC00) {
        let codeNext = str.charCodeAt(++i);

        if (i < strLength && codeNext >= 0xDC00 && codeNext <= 0xDFFF) byteLength += 4;
      }
      else if (code >= 0xE000) byteLength += 3;
    }
    return byteLength;
  }

  // 메시지 단가 계산 (SMS/LMS 자동 판별) //
  function getUnitPrice() {
    return checkValueByte(content) < 90 ? pricing.sms : pricing.lms;
  }

  // 회원수 계산 //
  function decideMemberCount() {
    return t('messageSend.sendCountInfo', { count: selectedMembers.length.toLocaleString('ko-KR') });
  }

  // 결제 금액 //
  function decideCalcPrice() {
    let total = getUnitPrice() * selectedMembers.length;
    return t('messageSend.sendPrice', { price: total.toLocaleString('ko-KR') });
  }

  // 완료모달 텍스트 결정 //
  function decideCompleteMemberCount() {
    return t('messageSend.completeMemberCount', { count: selectedMembers.length.toLocaleString('ko-KR') });
  }

  // 회원 선택 추가 모달에서 회원추가 버튼 클릭시 //
  function onClickAdditionButton(selectedMembers) {
    let newTotalMembers = totalMembers.slice();
    let members = lodash.cloneDeep(selectedMembers);

    newTotalMembers.map((data) => data.isClicked = false);
    members.map((data) => data.isClicked = false);

    setTotalMembers(newTotalMembers);
    setSelectedMembers(members);
    setIsClickedSelectedMember(false);
  }

  // 전송회원 체크박스 선택시 //
  function onClickMemberInfo(data) {
    let newSelectedMembers = selectedMembers.slice();
    let index = newSelectedMembers.findIndex(item => item.memberId === data.memberId);

    newSelectedMembers[index].isClicked = !newSelectedMembers[index].isClicked;

    setSelectedMembers(newSelectedMembers);
  }

  // 선택삭제 버튼 클릭시 //
  function onClickSelectedDelete() {
    let newSelectedMembers = selectedMembers.slice();
    let saveMembers = [];

    newSelectedMembers.map((data) => {
      if (!data.isClicked) saveMembers.push(data);
    })

    setSelectedMembers(saveMembers);
  }

  // 전체삭제 버튼 클릭시 //
  function onClickAllDelete() {
    let newMembers = totalMembers.slice();

    newMembers.map((data) => data.isClicked = false);

    setTotalMembers(newMembers);
    setSelectedMembers([]);
  }

  // 회원목록에서 불러오기 //
  function onClickMemberLoading() {
    let newTotalMembers = totalMembers.slice();
    let newSelectedMembers = selectedMembers.slice();

    newTotalMembers.map((data) => data.isClicked = false);

    for (let i = 0; i < newSelectedMembers.length; i++) {
      for (let j = 0; j < newTotalMembers.length; j++) {
        if (newSelectedMembers[i].memberId === newTotalMembers[j].memberId) {
          newTotalMembers[j].isClicked = true;
          break;
        }
      }
    }

    setTotalMembers(newTotalMembers);
    setIsClickedSelectedMember(true);
  }

  // 카드 미등록 가드 — 미등록 시 카드등록 안내 모달 노출 후 false 반환 (문자 발송·카카오 알림톡 공용) //
  function checkRegistrationCard() {
    if (!isRegistrationCard) {
      setIsViewRegistrationCard(true);
      return false;
    }
    return true;
  }

  // 입력하기 버튼 클릭시 (Toss BrandPay v2 SDK) — useTossCardRegister 훅 위임 //
  function onClickRegistrationCard() {
    registerCard({
      onSuccess: () => {
        setIsRegistrationCard(true);
        setIsViewRegistrationCard(false);
      }
    });
  }

  // 메시지 보내기 버튼 클릭시 //
  function onClickSendMessage() {
    let memberIds = [];

    selectedMembers.map((data) => {
      memberIds.push(data.memberId);
    })

    if (memberIds.length === 0) {
      alert(t('messageSend.alertNoMembers'));
      return;
    }
    else if (content === '') {
      alert(t('messageSend.alertEnterContent'));
      return;
    }

    if (isRegistrationCard) {
      if (isSending) {
        alert(t('messageSend.alertSending'));
        return;
      }

      setIsSending(true);

      let requestData = {
        title: storeName,
        content: content + '\n\n' + UNSUBSCRIBE_TEXT,
        memberIds: memberIds
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('message/send_target', 'POST', requestData);

          if (responseData.status === 200) {
            setTimeout(() => {
              setIsViewCompleteSend(true);
              setIsSending(false);
              setContent('');
            }, 600)
          }
          else {
            alert(t('messageSend.alertSendFailed'));
            setIsSending(false);
          }
        }
      )();

    }
    else setIsViewRegistrationCard(true);
  }

  // 자동메세지 사용 버튼 전환시 //
  function onClickUseSettingBox() {
    if (isProgress) {
      alert(t('messageSend.alertSaving'));
      return;
    }

    setIsProcess(true);

    let requestData = {
      isUseAutoMessage: !isClickedTotalSetting
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('message_setting/switch', 'POST', requestData);

        if (responseData.status === 200) {
          setIsClickedTotalSetting(!isClickedTotalSetting);
          setIsProcess(false);
        }
        else {
          setIsProcess(false);
        }
      }
    )();

  }

  // 수정하기 버튼 클릭시 //
  function onClickEditText(data) {
    let newData = lodash.cloneDeep(data);

    setSelectedData(newData);
    setIsEditPush(false);
    setIsViewMessageEditModal(true);
  }

  // 자동알림(푸시) 문구 수정모달 열기 //
  function onClickEditPushText(data) {
    let newData = lodash.cloneDeep(data);

    setSelectedData(newData);
    setIsEditPush(true);
    setIsViewMessageEditModal(true);
  }

  // 자동메세지 수정모달 취소버튼 클릭시 //
  function onClickExitInEditModal() {
    setSelectedData(undefined);
    setIsEditPush(false);
    setIsViewMessageEditModal(false);
  }

  // 자동메세지 수정모달 저장 버튼 클릭시 //
  function onClickSave(data) {
    if (isProgress) {
      alert(t('messageSend.alertSavingInProgress'));
      return;
    }

    setIsProcess(true);

    let requestData = {
      id: selectedData.id,
      storeId: selectedData.storeId,
      division: selectedData.division,
      text: data,
      title: selectedData.title,
      applyDay: selectedData.applyDay,
      applyTime: selectedData.applyTime,
      isUseSetting: selectedData.isUseSetting
    }

    // 만료/홀딩 편집은 applyTime "HH:MM" 문자열 → 시/분 정수로 분리해 전송 (SMS·푸시 공통) //
    if (typeof selectedData.applyTime === 'string' && selectedData.applyTime.includes(':')) {
      const [hour, minute] = selectedData.applyTime.split(':');

      requestData.applyTime = parseInt(hour, 10) || 0;
      requestData.applyMinute = parseInt(minute, 10) || 0;
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const endpoint = isEditPush ? 'push_setting/save' : 'message_setting/save';

        const responseData = await fetchModule.postDataVersion2(endpoint, 'POST', requestData);

        if (responseData.status === 200) {
          if (isEditPush) setPushRendering(!pushRendering);
          else setRendering(!rendering);

          setIsViewMessageEditModal(false);
          setIsProcess(false);
          setIsEditPush(false);
        }
      }
    )();
  }

  // 이전 페이지 클릭시 //
  function onClickPrev() {
    if (nowPage > 0) setNowPage(nowPage - 1);
  }

  // 다음 페이지 클릭시 //
  function onClickNext() {
    if (nowPage < totalPage - 1) setNowPage(nowPage + 1);
  }

  return (
    <TopLevelWrapper>
      {
        isViewCompleteSend &&
        <SendCompleteModal text={decideCompleteMemberCount()} onClickExit={() => setIsViewCompleteSend(false)} />
      }
      {
        isViewRegistrationCard &&
        <NotRegistrationCardModal division='Notice' setIsViewModal={setIsViewRegistrationCard} onClickRegistCard={onClickRegistrationCard} />
      }
      {
        isClickedSelectedMember &&
        <SendMemberSelectModal memberList={totalMembers} onClickAdditionButton={onClickAdditionButton} onClickExit={() => setIsClickedSelectedMember(false)} />
      }
      {
        isViewMessageEditModal &&
        <AutoMessageEditModal data={selectedData} onClickExit={onClickExitInEditModal} onClickSave={onClickSave} />
      }
      <TitleBar>
        <TextWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} hover='default'>{t('messageSend.title')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='default'>{t('messageSend.description')}</Text>
        </TextWrapper>
      </TitleBar>
      <ColumnWrapper>
        <ColumnButton isClicked={clickDivision === 'SendMessage'} onClick={() => onClickTab('SendMessage')}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={clickDivision === 'SendMessage' ? theme.subBackground : theme.subText} hover='pointer'>{t('messageSend.tabSend')}</Text>
        </ColumnButton>
        <ColumnButton isClicked={clickDivision === 'SettingAutoMessage'} onClick={() => onClickTab('SettingAutoMessage')}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={clickDivision === 'SettingAutoMessage' ? theme.subBackground : theme.subText} hover='pointer'>{t('messageSend.tabAutoMessage')}</Text>
        </ColumnButton>
        <ColumnButton isClicked={clickDivision === 'AutoNotification'} onClick={() => onClickTab('AutoNotification')}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={clickDivision === 'AutoNotification' ? theme.subBackground : theme.subText} hover='pointer'>{t('messageSend.tabAutoNotifications')}</Text>
        </ColumnButton>
        <ColumnButton isClicked={clickDivision === 'MessageHistory'} onClick={() => onClickTab('MessageHistory')}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={clickDivision === 'MessageHistory' ? theme.subBackground : theme.subText} hover='pointer'>{t('messageSend.tabHistory')}</Text>
        </ColumnButton>
        <ColumnButton isClicked={clickDivision === 'PhoneNumberManagement'} onClick={() => onClickTab('PhoneNumberManagement')}>
          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={clickDivision === 'PhoneNumberManagement' ? theme.subBackground : theme.subText} hover='pointer'>{t('messageSend.tabSettings')}</Text>
        </ColumnButton>
      </ColumnWrapper>
      {
        clickDivision === 'SendMessage' &&
        <SendMessageBox
          isSending={isSending}
          storeName={storeName}
          content={content}
          setContent={setContent}
          selectedMembers={selectedMembers}
          onClickMemberLoading={onClickMemberLoading}
          onClickSelectedDelete={onClickSelectedDelete}
          onClickAllDelete={onClickAllDelete}
          onClickMemberInfo={onClickMemberInfo}
          decideMemberCount={decideMemberCount}
          decideCalcPrice={decideCalcPrice}
          onClickSendMessage={onClickSendMessage} />
      }
      {
        clickDivision === 'SettingAutoMessage' &&
        <AutoMessageSettingBox
          isClickedTotalSetting={isClickedTotalSetting}
          onClickUseSettingBox={onClickUseSettingBox}
          onRequireCard={checkRegistrationCard}
          registration={registration}
          setRegistration={setRegistration}
          attendanceClass={attendanceClass}
          setAttendanceClass={setAttendanceClass}
          expired={expired}
          setExpired={setExpired}
          isDuplicateSmsLimited={duplicateLimit.isDuplicateSmsLimited}
          onClickDuplicateSms={() => onClickDuplicateLimit('isDuplicateSmsLimited')}
          onClickEditText={onClickEditText} />
      }
      {
        clickDivision === 'AutoNotification' &&
        <AutoNotificationBox
          onRequireCard={checkRegistrationCard}
          expired={pushExpired}
          setExpired={setPushExpired}
          isDuplicatePushLimited={duplicateLimit.isDuplicatePushLimited}
          onClickDuplicatePush={() => onClickDuplicateLimit('isDuplicatePushLimited')}
          isDuplicateKakaoLimited={duplicateLimit.isDuplicateKakaoLimited}
          onClickDuplicateKakao={() => onClickDuplicateLimit('isDuplicateKakaoLimited')}
          onClickEdit={onClickEditPushText} />
      }
      {
        clickDivision === 'MessageHistory' &&
        <MessageHistoryBox
          viewMessageHistory={viewMessageHistory}
          nowPage={nowPage}
          totalPage={totalPage}
          onClickPrev={onClickPrev}
          onClickNext={onClickNext} />
      }
      {
        clickDivision === 'PhoneNumberManagement' &&
        <PhoneNumberManagementBox />
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
  
  margin: 0px 0px 252px 20px;

  width: 100%;
`;

const TitleBar = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 992px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 20px 0px 0px 0px;
  gap: 10px;
`;

const ColumnButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 20px;

  box-sizing: border-box;
  height: 31px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.subBackground}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;
